import OrganizationCost from '../../../Partials/Elements/OrganizationCost/OrganizationCost'
import FavButton from '../../../Partials/Elements/Buttons/FavButton'

function OrganizationSummary({singleOrganization, favorite, handleClick, consumer}) {
  return (
    <div className="col left">
        <h1>
            {
                consumer
                ?
                    consumer.language === 'english'
                    ?
                      singleOrganization?.engName
                    :
                        singleOrganization?.name
                :
                    singleOrganization?.name
            }
            <FavButton
              favorite={favorite}
              handleClick={handleClick} 
            />
        </h1>
        <div className="kh_porisima">
            <OrganizationCost cost={singleOrganization?.cost} />
        </div>

        <p className='desc'>
           {
                consumer
                ?
                    consumer.language === 'english'
                    ?
                      singleOrganization?.engDescription
                    :
                        singleOrganization?.description
                :
                    singleOrganization?.description
            }
        </p>
    </div>
  )
}

export default OrganizationSummary